export type DormantFeature = "HISTORY_REVAMP" | "FETCH_BANKS_FROM_API";

/**
 * Features whose code is kept but switched off in production.
 *
 * Both were Amplitude Experiment flags that were inactive in production (so every user got the "off" behaviour)
 * until Amplitude Experiment was removed (2026-10). Flip a value to `true` to launch it, or move it to a Nexus key.
 */
export const DORMANT_FEATURES: Readonly<Record<DormantFeature, boolean>> = {
  /** Retired Amplitude key `bison-dis-history-revamp`: the revamped domestic/multi transaction history UI. */
  HISTORY_REVAMP: false,
  /** Retired Amplitude key `bison-dis-fetch-banks-api`: load the bank list from the API instead of the whitelist. */
  FETCH_BANKS_FROM_API: false
};
